import React, { Component } from "react";
import _ from "lodash";

export interface InputProps {
    field?: any;
    form?: any;
    inputtype?: string;
    placeholder?: string;
    givenid?: string;
    disabled?: boolean;
    decimal?: boolean;
    isConfig?: boolean;
    items?: { label: any; value: any; appendex?: any }[];
}

export interface InputState {
    values?: any;
}


export default class BaseBetFreqPrizesArray extends Component<InputProps, InputState> {

    constructor(props) {
        super(props);
        this.state = {
            values: this.props.field.value?_.cloneDeep(this.props.field.value).map((item, index) => {
                return {
                    ...item,
                    order: index,
                    index: index
                }
            }) : []
        }
    }
    
    setFieldTouched = () => {
        const { field } = this.props;
        let { touched } = this.props.form;
        touched[field.name] = true;
        this.props.form.setTouched(touched);
    }

    updateFormValue = (newValue) => {
        let value = [...newValue].map(item => {
            delete item.order;
            delete item.index;
            return item;
        })
        this.props.form.setFieldValue(this.props.field.name, value);
    }

    deleteItem(index) {
        this.setFieldTouched();
        const newValue = [...this.state.values];
        newValue.splice(index, 1);
        this.updateFormValue(_.cloneDeep(newValue));
        this.setState({values: newValue});

    }

    addItem = () => {
        this.setFieldTouched();
        let newValue =
            typeof this.state.values !== undefined
                ? [...this.state.values]
                : [];
        let newItem = {}
        newItem['order'] = typeof this.state.values !== undefined ? this.state.values.length : 0
        newItem['index'] = typeof this.state.values !== undefined ? this.state.values.length : 0
        this.props.items.map(item=>newItem[item.value]=undefined)
        newValue.push(newItem)
        this.updateFormValue(_.cloneDeep(newValue));
        this.setState({
            values: newValue
        });
    }

    changeValue = (value, order, key) => {
        this.setFieldTouched();
        const newValue = [...this.state.values];
        newValue[order][key] = value;
        this.updateFormValue(_.cloneDeep(newValue));
        this.setState({
            values: newValue
        });
    }
    /*
    changeRepeat = (repeat, index) => {
        this.setFieldTouched();
        const newValue = [...this.state.values];
        newValue[index]['repeat'] = parseInt(repeat);
        this.updateFormValue(_.cloneDeep(newValue));
        this.setState({
            values: newValue
        });
    }
    */
    moveDown = (index) => {
        let newValue = [...this.state.values];
        if (index < newValue.length - 1) {
            let element = newValue[index];
            newValue.splice(index, 1);
            newValue.splice(index + 1, 0, element);
            newValue.map((item, index) => {
                item.order = index;
                return item;
            })
            this.updateFormValue(_.cloneDeep(newValue));
            this.setState({
                values: newValue
            });
        }
    }

    moveUp = (index) => {
        if (index > 0) {
            let newValue = [...this.state.values];
            let element = newValue[index];
            newValue.splice(index, 1);
            newValue.splice(index - 1, 0, element);
            newValue.map((item, index) => {
                item.order = index;
                return item;
            })
            this.updateFormValue(_.cloneDeep(newValue));
            this.setState({
                values: newValue
            });
        }
    }

    render() {
        const fieldName = this.props.field.name;
        const errors =
            this.props.form.errors[fieldName] != "Field is required."
            || (this.props.isConfig && !this.props.disabled)
                ? this.props.form.errors[fieldName]
                : this.props.form.touched[fieldName] &&
                this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                {Array.isArray(errors) && errors.map((error, index) => {
                    if (typeof error === 'object') {
                        return Object.keys(error).map((objKey, objIndex) => {
                            return <span key={`${index}-${objIndex}`} className="input-error-message">{error[objKey]}</span>
                        })
                    } else {
                        return <span key={`${index}-single`} className="input-error-message">{error}</span>
                    }
                })}
                {!Array.isArray(errors) && (<span className="input-error-message">{errors}</span>)}
            </div>
        );

        const props = { ...this.props };
        delete props.decimal;

        const fieldProps = { ...this.props.field };
        delete fieldProps.value;

        return (
            <div id={this.props.givenid + "Input"}>
                <div
                    className={
                        "array-input input-group input-jackpot-array"
                    }
                >
                    {!this.props.disabled && (
                        <button className="add-obj-button hidden-disabled" onClick={this.addItem}><i className="icon-plus-light"></i></button>
                    )}
                    <div
                        style={{ padding: "0px 16px 3px 16px", height: "auto", width: "auto" }}
                        className="input"
                    >
                        {this.state.values == undefined ||
                            (this.state.values.length == 0 && (
                                <span
                                    style={{
                                        opacity: 0.7,
                                        color: "#ff396f",
                                        display: "flex",
                                        lineHeight: "40px",
                                        marginBottom: "-3px"
                                    }}
                                >
                                    No values set yet
                                </span>
                            ))}

                            <table className="array-table" cellSpacing="0" cellPadding="0">
                                <thead>
                                    <tr>

                                        {this.props.items.map((value, index) => {
                                            return (<th key={'th'+index}>{value.label}</th>)})}
                                        <th className="hidden-disabled"></th>
                                        <th className="hidden-disabled"></th>
                                    </tr>
                                </thead>

                                {this.state.values !== undefined &&
                                    this.state.values.length > 0 && (
                                            <tbody>
                                                {this.state.values.map((value, index) => {
                                                    return (
                                                        <tr key={index}>
                                                        {this.props.items.map((item_value, item_index) => {
                                                            return (
                                                                <td key={'td'+item_index}>
                                                                    <input
                                                                        key={`${value.index}-value_${item_value.value}`}
                                                                        type="number"
                                                                        defaultValue={value[`${item_value.value}`]}
                                                                        onChange={(event) => this.changeValue(event.currentTarget.value, index, `${item_value.value}`)}
                                                                        placeholder={item_value.value == 0 ? "≥ 0" : "≥ 1"}
                                                                        disabled={this.props.disabled}
                                                                    />
                                                                </td>
                                                            )})}
                                                        {!this.props.disabled && (
                                                              <td className="hidden-disabled">
                                                                <div className="order">
                                                                    <button
                                                                        className="order-btn"
                                                                        onClick={() => this.moveUp(index)}
                                                                        disabled={index == 0 || this.props.disabled}>
                                                                        {index > 0 && <i className="icon-chevron-up-light"></i>}
                                                                    </button>
                                                                    <button
                                                                        className="order-btn"
                                                                        onClick={() => this.moveDown(index)}
                                                                        disabled={index == this.state.values.length - 1 || this.props.disabled}>
                                                                        {index < this.state.values.length - 1 && <i className="icon-chevron-down-light"></i>}
                                                                    </button>
                                                                </div>
                                                             </td>
                                                        )}
                                                        {!this.props.disabled && (
                                                            <td className="hidden-disabled">
                                                                <button className="remove-obj-button" onClick={() => this.deleteItem(index)}><i className="icon-times-solid"></i></button>
                                                            </td>
                                                        )}
                                                    </tr>
                                                    )}
                                                )}
                                            </tbody>
                                    )}
                            </table>
                    </div>
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
